/* TS&CO · motion layer for Horizon (código próprio). */
(() => {
  if (window.__tsnMotion) return;
  window.__tsnMotion = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Hero ---------- */
  // Busca slides e miniaturas sempre "ao vivo": o editor da Shopify pode trocar o
  // conteúdo da seção sem recriar o elemento raiz, e referências antigas deixariam
  // o slide visível sem a classe is-on (banner vazio).
  function initHero(root) {
    if (root.__tsn) return; root.__tsn = true;
    const q = (sel) => root.querySelector(sel);
    const slidesNow = () => [...root.querySelectorAll('.tsn-slide')];
    if (!slidesNow().length) return;
    const dur = (parseFloat(root.dataset.autoplay) || 6) * 1000;
    let i = Math.max(0, slidesNow().findIndex((s) => s.classList.contains('is-on')));
    let t0 = performance.now(), paused = inEditor;

    const go = (n) => {
      const slides = slidesNow();
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-on', k === i));
      const s = slides[i];
      root.querySelectorAll('.tsn-dock__thumb [data-index]').forEach((t) => (t.hidden = Number(t.dataset.index) !== i));
      // Só os textos do card de vidro (os slides também têm data-dock-*, que não podem ser sobrescritos).
      const title = q('.tsn-dock__text [data-dock-title]'), sub = q('.tsn-dock__text [data-dock-sub]'), bar = q('.tsn-dock__bar i');
      if (title) title.textContent = s.dataset.dockTitle || '';
      if (sub) sub.textContent = s.dataset.dockSub || '';
      t0 = performance.now();
      if (bar) bar.style.width = '0%';
    };
    root.__go = (n) => { go(n); };
    root.__pause = (v) => (paused = v);
    // Delegação: continua funcionando mesmo se os botões forem recriados.
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-next]')) go(i + 1);
      else if (e.target.closest('[data-prev]')) go(i - 1);
    });

    let sx = null;
    root.addEventListener('touchstart', (e) => (sx = e.touches[0].clientX), { passive: true });
    root.addEventListener('touchend', (e) => {
      if (sx === null) return;
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
      sx = null;
    });
    document.addEventListener('visibilitychange', () => { t0 = performance.now(); });

    // Garante sempre um slide visível (inclusive depois de atualizações do editor).
    new MutationObserver(() => {
      const slides = slidesNow();
      if (slides.length && !slides.some((s) => s.classList.contains('is-on'))) go(Math.min(i, slides.length - 1));
    }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    if (reduce) return;
    const loop = (now) => {
      if (!root.isConnected) return;
      const bar = q('.tsn-dock__bar i');
      if (slidesNow().length > 1 && !paused && !document.hidden) {
        const p = Math.min((now - t0) / dur, 1);
        if (bar) bar.style.width = p * 100 + '%';
        if (p >= 1) go(i + 1);
      } else {
        t0 = now - (parseFloat(bar?.style.width) || 0) / 100 * dur;
      }
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }

  /* ---------- Abas ---------- */
  function initTabs(root) {
    if (root.__tsn) return; root.__tsn = true;
    const tabs = [...root.querySelectorAll('.tsn-tab')];
    const panels = [...root.querySelectorAll('.tsn-grid')];
    const allLink = root.querySelector('[data-all-link]');
    let busy = false;
    const show = (k) => {
      tabs.forEach((t, j) => t.setAttribute('aria-selected', j === k ? 'true' : 'false'));
      const cur = panels.find((p) => !p.hidden);
      const nxt = panels[k];
      if (allLink && tabs[k].dataset.url) allLink.href = tabs[k].dataset.url;
      if (!cur || cur === nxt) return;
      if (reduce) { cur.hidden = true; nxt.hidden = false; return; }
      busy = true;
      const h = cur.offsetHeight;
      cur.classList.add('is-leaving');
      setTimeout(() => {
        cur.hidden = true; cur.classList.remove('is-leaving');
        nxt.style.minHeight = h + 'px';
        nxt.hidden = false; nxt.classList.remove('is-entering'); void nxt.offsetWidth; nxt.classList.add('is-entering');
        setTimeout(() => { nxt.style.minHeight = ''; busy = false; }, 700);
      }, 300);
    };
    tabs.forEach((t, k) => t.addEventListener('click', () => {
      if (busy || t.getAttribute('aria-selected') === 'true') return;
      show(k);
    }));
    root.__show = (k) => show(k);
  }

  /* ---------- Manifesto ---------- */
  function initManifesto(root) {
    if (root.__tsn) return; root.__tsn = true;
    const p = root.querySelector('[data-words]');
    if (!p) return;
    p.innerHTML = p.textContent.trim().split(/\s+/).map((w) => `<span class="tsn-w">${w}</span>`).join(' ');
  }

  /* ---------- Revelar ao rolar ---------- */
  let io;
  function initReveal(scope) {
    if (reduce || inEditor || !('IntersectionObserver' in window)) return;
    io = io || new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.remove('is-pre'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -10% 0px' });
    scope.querySelectorAll('.tsn-reveal').forEach((el) => {
      if (el.__tsn) return; el.__tsn = true;
      if (el.getBoundingClientRect().top > window.innerHeight) el.classList.add('is-pre');
      io.observe(el);
    });
  }

  /* ---------- Rolagem: header, capítulos, manifesto ---------- */
  function onScroll() {
    const pw = document.querySelector('.page-wrapper');
    const y = Math.max(window.scrollY, pw ? pw.scrollTop : 0);
    document.documentElement.classList.toggle('tsn-scrolled', y > 30);
    if (reduce) return;

    document.querySelectorAll('[data-tsn-stack]').forEach((stack) => {
      const cs = [...stack.querySelectorAll('.tsn-chapter')];
      cs.forEach((c, k) => {
        const n = cs[k + 1];
        if (!n) return;
        const h = c.offsetHeight || 1;
        const p = Math.max(0, Math.min(1, 1 - (n.getBoundingClientRect().top - c.getBoundingClientRect().top) / h));
        c.style.transform = `scale(${1 - 0.07 * p})`;
        const d = c.querySelector('.tsn-chapter__dim');
        if (d) d.style.opacity = (0.45 * p).toFixed(3);
      });
    });

    document.querySelectorAll('[data-tsn-manifesto]').forEach((m) => {
      const words = m.querySelectorAll('.tsn-w');
      if (!words.length) return;
      const r = m.getBoundingClientRect(), vh = window.innerHeight;
      const p = Math.max(0, Math.min(1, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      const n = inEditor ? words.length : Math.round(p * words.length);
      words.forEach((w, k) => w.classList.toggle('is-lit', k < n));
    });
  }
  let ticking = false;
  const schedule = () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => { onScroll(); ticking = false; });
  };
  // Horizon rola a .page-wrapper no desktop e a janela no celular: capturar ambos.
  document.addEventListener('scroll', schedule, { capture: true, passive: true });
  window.addEventListener('resize', schedule);

  /* ---------- Boot ---------- */
  function init(scope = document) {
    scope.querySelectorAll('[data-tsn-hero]').forEach(initHero);
    scope.querySelectorAll('[data-tsn-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-tsn-manifesto]').forEach(initManifesto);
    initReveal(scope);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  /* ---------- Editor de temas ---------- */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const block = e.target;
    const hero = block.closest('[data-tsn-hero]');
    if (hero && hero.__go) {
      const idx = [...hero.querySelectorAll('.tsn-slide')].indexOf(block.closest('.tsn-slide') || block);
      if (idx > -1) { hero.__go(idx); hero.__pause && hero.__pause(true); }
    }
    const tabs = block.closest('[data-tsn-tabs]');
    if (tabs && tabs.__show) {
      const idx = Number(block.dataset.tabIndex);
      if (!Number.isNaN(idx)) tabs.__show(idx);
    }
  });
})();
